import { Bold, Flex } from './TremorCompat';
import { Panel, Text } from 'rsuite';

import { DisplayIcon } from './DisplayIcon';

export const DisplayFaults = ({ icon, tc, register, text, borderOff }) => {
  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4">
        <DisplayIcon icon={icon} />
        <div className="truncate">
          <Text className="display-linebreak" color={tc}>
            <Bold>
              {text} {register.title}{' '}
            </Bold>
            {register.display}
          </Text>
        </div>
      </Flex>
    </Panel>
  );
};
